import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'

export const TemplateContactSalesSchema = buildEntrySchemaFor('templateContactSalesForm', {
  fields: z.object({
    body: RichTextSchema.optional(),
    headline: z.string(),
    label: z.string().optional(),
  }),
})

export type TemplateContactSalesForm = z.infer<typeof TemplateContactSalesSchema>
